import React, { useRef } from 'react';
import styled from 'styled-components';
import { Button } from './Button';

export interface UploadFieldProps {
  label?: string;
  accept?: string;
  disabled?: boolean;
  hasFile?: boolean;
  onUpload?: (file: File) => void;
  onReplace?: (file: File) => void;
  onView?: () => void;
}

const UploadFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HiddenInput = styled.input`
  display: none;
`;

export const UploadField: React.FC<UploadFieldProps> = ({
  label,
  accept,
  disabled,
  hasFile,
  onUpload,
  onReplace,
  onView,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const triggerSelect = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (hasFile && onReplace) onReplace(file);
    else if (onUpload) onUpload(file);
    e.target.value = '';
  };

  return (
    <UploadFieldContainer>
      {label && <span style={{ fontSize: '12px', color: '#64748b' }}>{label}</span>}
      <HiddenInput
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
      />
      <Button size="sm" variant="ghost" onClick={triggerSelect} disabled={disabled}>
        {hasFile ? 'Replace' : 'Upload'}
      </Button>
      <Button size="sm" variant="outline" onClick={onView} disabled={!hasFile}>
        View
      </Button>
    </UploadFieldContainer>
  );
};
